import React from "react";
import { Info } from "lucide-react";

/**
 * TerminologyHint — small, non-intrusive info banner explaining the
 * DT (Down Time) vs NPT (Non-Productive Time) terminology used in the
 * compact shift-briefing reports (Handover Notes, Pre-Tour Briefing).
 *
 * Other RigSentinel reports (Daily Drilling Report, Daily Mud Report,
 * HSE Incident, BOP Test, Kick Sheet, LOT/FIT, JSA) continue to use the
 * industry-standard NPT — this banner makes the difference visible to
 * the crew so the terminology shift is intentional and explained.
 */
export default function TerminologyHint() {
  return (
    <div
      data-testid="terminology-hint-banner"
      role="note"
      className="mt-2 mb-3 rounded-md border px-3 py-2 flex items-start gap-2"
      style={{
        background: "rgba(245, 180, 0, 0.06)",
        borderColor: "rgba(245, 180, 0, 0.25)",
        color: "var(--rs-text-2, #cfd6df)",
      }}
    >
      <Info
        className="w-3.5 h-3.5 shrink-0 mt-0.5"
        style={{ color: "var(--rs-amber, #f5b400)" }}
      />
      <p
        className="text-[11px] leading-snug"
        data-testid="terminology-hint-text"
      >
        <span className="font-semibold tracking-wide">Note:</span> This report
        uses <span className="font-mono-rs font-semibold">DT</span>{" "}
        (Down Time) for equipment and operational delays. Other reports
        (DDR, DMR) use <span className="font-mono-rs font-semibold">NPT</span>{" "}
        (Non-Productive Time).
      </p>
    </div>
  );
}
